import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MediaSection } from '@polestar/component-warehouse-react/components/section/Section';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { useSSRSafeId } from '@polestar/component-warehouse-react/contexts/ssr';
import { CrossAxisAlignments, MainAxisAlignments, } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import { maximumWidth } from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
import Image from '@polestar/component-warehouse-react/components/image/Image';
const ImporterBannerBottom = forwardRef(({ message, logo, ...props }, ref) => {
    const memoizedId = useSSRSafeId('importer-top-banner', props.id);
    return (React.createElement(ImporterBannerBottomMediaSection, { ...props, ref: ref, id: memoizedId },
        React.createElement(Wrapper, null,
            React.createElement(MessageWrapper, null,
                React.createElement(Message, null, message),
                logo && (React.createElement(LogoWrapper, null,
                    React.createElement(StyledImage, { ...logo, alt: "" })))))));
});
ImporterBannerBottom.displayName = 'ImporterBannerBottom';
export default ImporterBannerBottom;
const ImporterBannerBottomMediaSection = styled(MediaSection)(({ theme }) => css(css `
    background-color: ${theme.importerBottomBanner.background};
    max-width: unset;

    ${responsiveStyles({
    padding: {
        mobile: `0 ${Grids.mobile.gutter}`,
        tablet: `0 ${Grids.tablet.gutter}`,
        desktop: `0 ${Grids.desktop.gutter}`,
    },
})}
  `));
const Wrapper = styled.div `
  padding-block: ${Spacings.medium};
  margin: 0 auto;

  ${responsiveStyles({
    padding: {
        mobile: `${Spacings.medium} ${Grids.mobile.gutter}`,
        tablet: `${Spacings.medium} ${Spacings.large}`,
        desktop: `${Spacings.large} ${Spacings.xLarge}`,
        desktopWide: `${Spacings.large} ${Spacings.xxxxLarge}`,
    },
    maxWidth: {
        mobile: '100%',
        desktopWide: `${maximumWidth}px`,
    },
})},
`;
const MessageWrapper = styled.div(({ theme }) => css `
    position: relative;
    color: ${theme.importerBottomBanner.color};
    display: flex;
    justify-content: ${MainAxisAlignments.spaceBetween};
    align-items: ${CrossAxisAlignments.start};
    width: 100%;
    text-decoration: none;
    text-align: start;
  `);
const LogoWrapper = styled.div `
  height: ${createCustomSpacing(40 / 16)};
  display: flex;
  align-items: ${CrossAxisAlignments.center};

  ${responsiveStyles({
    paddingInlineStart: {
        mobile: Spacings.medium,
        desktop: Spacings.large,
    },
})};
`;
const StyledImage = styled(Image)(css `
  max-height: 40px;
  max-width: 120px;
`);
const Message = styled.p `
  min-height: ${createCustomSpacing(40 / 16)};
  display: flex;
  align-items: ${CrossAxisAlignments.center};

  ${responsiveStyles({
    fontSize: {
        mobile: Spacings.small,
        desktop: Spacings.medium,
    },
    lineHeight: {
        mobile: createCustomSpacing(14 / 16),
        desktop: createCustomSpacing(18 / 16),
    },
})};
`;
